module.exports = __webpack_public_path__ + "static/media/10. Fruit Cake Rusk 300 g.a8275a84.jpg";